module.exports = __webpack_public_path__ + "img/IO.84de1d2d.svg";